// components/Toolbar/tools/SelectTool.js
import React from 'react';
import Button from '../Toolbar/Button';
import { connect } from 'react-redux';
import OptionsPanel from '../OptionsPanel/OptionsPanel';
import styles from './Color.scss';
import { colorOptions } from './colorOptions';
import {
  setToolbarOptionsPanel,
  updateColor,
} from '../../../../redux/actions/canvas_editor';
import { colorObjectStyle } from '../../helpers/fabricHelpers';

import { __ } from '../../../../core/utils';

const Color = ({
  canvas_editor: { color, toolbarOptionsPanel, fabricCanvases, activeTool },
}) => {
  const isOptionsOpen = toolbarOptionsPanel === 'color';

  const restoreTextboxEditing = (canvas, obj) => {
    requestAnimationFrame(() => {
      if (!canvas || !obj) return;
      if (!canvas.getObjects().includes(obj)) return;

      canvas.setActiveObject(obj);

      if (!obj.isEditing && obj.editable) {
        obj.enterEditing();
      }

      obj.hiddenTextarea?.focus();
      canvas.requestRenderAll();
    });
  };

  const applyColorToActiveObject = (colorHex) => {
    if (!fabricCanvases) return;

    Object.entries(fabricCanvases).forEach(([pageNumber, canvas]) => {
      const obj = canvas.getActiveObject();
      if (!obj) return;
      const shouldRestoreEditing =
        activeTool === 'textbox' && obj.objectType === 'textbox';

      colorObjectStyle(obj, colorHex);
      canvas.requestRenderAll();

      canvas.fire('object:modified', { target: obj, source: 'toolbar' });

      if (shouldRestoreEditing) {
        restoreTextboxEditing(canvas, obj);
      }
    });
  };

  const toggleOptions = () => {
    setToolbarOptionsPanel(isOptionsOpen ? '' : 'color');
  };

  const handleColorSelect = (colorKey) => {
    const findColor = colorOptions.find((opt) => opt.key === colorKey);
    if (!findColor) return;

    updateColor(findColor);
    setToolbarOptionsPanel(isOptionsOpen ? '' : 'color');
    applyColorToActiveObject(findColor.hex);
  };

  return (
    <div className={styles.wrapper} id='wizard'>
      <Button
        id={color?.key}
        label={__('canvas.toolbar.color.' + color?.key)}
        icon={color?.icon}
        onClick={toggleOptions}
        extraClass={isOptionsOpen ? ['withBadge'] : ['withBadge', 'roundedUp']}
      />

      {isOptionsOpen && (
        <OptionsPanel
          value={color?.key}
          setValue={handleColorSelect}
          options={_.map(colorOptions, (color) => ({
            ...color,
            label: __('canvas.toolbar.color.' + color?.key),
          }))}
          customStyles={styles.optionsPanel}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
  };
};

export default connect(mapStateToProps, null)(Color);
